import { useEffect, useState } from "react";

import config from "config/appConfig";

const getScreenWidth = () => {
	return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
};

const useResize = () => {
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const onResize = () => {
			setIsMobile(getScreenWidth() <= config.sizes.mobile);
		};

		window.addEventListener("resize", onResize);
		setTimeout(() => {
			onResize();
		}, 150);

		return () => {
			window.removeEventListener("resize", onResize);
		};
	}, []);

	return { isMobile };
};

export default useResize;
